// Deterministic seeded picker for headline template arrays.
// Same seed → same pick, so each page renders a stable headline across reloads
// while different pages of the same shape get different copy.

// FNV-1a 32-bit hash. Plenty for picking from arrays of <16 templates.
function fnv1a(str) {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i += 1) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h >>> 0;
}

export function seedHash(seed) {
  if (seed === null || seed === undefined) return 0;
  return fnv1a(String(seed));
}

export function pickSeeded(seed, options) {
  if (!Array.isArray(options) || options.length === 0) return null;
  if (options.length === 1) return options[0];
  return options[seedHash(seed) % options.length];
}
